import type { StudioNewProjectFormInput } from "../../studio-shared/workflow/studio-workflow.js";
import type { V10ProjectMode } from "./v10-phase-model.js";

export type V10StartMethod = "intake" | "agency";

export interface V10NewProjectFormState {
  readonly businessName: string;
  readonly clientEntityName: string;
  readonly scopeSummary: string;
  readonly ownerLabel: string;
  readonly builderPath: "ENREIN_GENERATE" | "EXTERNAL_SUPPORTED";
  readonly targetOutcome: string;
  readonly primaryService: string;
  readonly serviceArea: string;
  readonly contactEmail: string;
  readonly primaryPhone: string;
  readonly externalUrl: string;
  readonly scanUrl: string;
  readonly startMethod: V10StartMethod;
  readonly sitePackageId: string;
  readonly lensId: string;
}

export const V10_EMPTY_NEW_PROJECT_FORM: V10NewProjectFormState = {
  businessName: "",
  clientEntityName: "",
  scopeSummary: "",
  ownerLabel: "",
  builderPath: "ENREIN_GENERATE",
  targetOutcome: "",
  primaryService: "",
  serviceArea: "",
  contactEmail: "",
  primaryPhone: "",
  externalUrl: "",
  scanUrl: "",
  startMethod: "intake",
  sitePackageId: "package-standard-5",
  lensId: "lens-flat-2",
};

export function v10FormToStudioInput(form: V10NewProjectFormState): StudioNewProjectFormInput {
  const businessName = form.businessName.trim();
  return {
    businessName,
    clientEntityName: form.clientEntityName.trim() || businessName,
    scopeSummary: form.scopeSummary.trim(),
    ownerLabel: form.ownerLabel.trim(),
    builderPath: form.builderPath,
    targetOutcome: form.targetOutcome.trim(),
    primaryService: form.primaryService.trim(),
    serviceArea: form.serviceArea.trim(),
    contactEmail: form.contactEmail.trim(),
    primaryPhone: form.primaryPhone.trim() || undefined,
    services: form.primaryService.trim() ? [{ name: form.primaryService.trim() }] : [],
    serviceAreas: form.serviceArea.trim() ? [{ name: form.serviceArea.trim() }] : [],
    sitePackageId: form.sitePackageId,
    lensId: form.lensId,
  };
}

export function validateV10NewProjectForm(mode: V10ProjectMode, form: V10NewProjectFormState): string | null {
  if (!form.businessName.trim()) return "Business name is required.";
  if (!form.clientEntityName.trim()) return "Client entity is required.";
  if (!form.scopeSummary.trim()) return "Scope summary is required.";
  if (!form.ownerLabel.trim()) return "Project owner is required.";
  if (!form.targetOutcome.trim()) return "Target outcome is required.";
  if (!form.builderPath) return "Builder path is required.";
  if (!form.sitePackageId) return "Site package is required.";
  if (mode === "DEFAULT_GENERATION" && form.startMethod === "intake" && !form.contactEmail.trim()) {
    return "Contact email is required for client intake links.";
  }
  if (mode === "EXISTING_SITE_SCAN" && !form.scanUrl.trim()) return "Website URL is required for relaunch scans.";
  if (mode === "EXTERNAL_PROOF_ONLY" && !form.externalUrl.trim()) return "External site URL is required.";
  return null;
}
